import type { Data } from './api'
import type {
  CalloAuthCodeData,
  CalloAuthCodeResponse,
  CalloCheckCodeData,
  CalloCheckCodeResponse,
  CalloRegistrationData,
  CalloTransferCheckCodeResponse,
} from '@/types/callo.types'
import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}user/callo/`

export const authCode = async (data: CalloAuthCodeData): Promise<Data<CalloAuthCodeResponse>> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}auth/email/code/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const checkCode = async (data: CalloCheckCodeData): Promise<Data<CalloCheckCodeResponse>> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}auth/email/code/check/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const registration = async (data: CalloRegistrationData): Promise<Data<CalloCheckCodeResponse>> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}auth/email/code/register/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const transferCode = async (data: CalloAuthCodeData): Promise<Data<CalloAuthCodeResponse>> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}transfer/email/code/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const transferCheckCode = async (data: CalloCheckCodeData): Promise<Data<CalloTransferCheckCodeResponse>> => {
  const { cookies } = useCookies()

  return axios.post(`${urlPrefix}transfer/email/code/check/`, data, {
    headers: {
      'X-CSRFToken': cookies.get('csrftoken'),
      'Content-Type': 'multipart/form-data',
    },
  })
}
